import { useEffect, useState } from 'react'
import { BaseModal } from './BaseModal'
import { registerUser, loginUser, UserData } from '../../lib/api'

const usernameBlocklistRe = /[\u515a\u4e60]/u

type Props = {
  isOpen: boolean
  defaultUsername?: string
  onRegistered: (username: string, userData?: UserData) => void
}

export const RegisterModal = ({ isOpen, defaultUsername = '', onRegistered }: Props) => {
  const [name, setName] = useState(defaultUsername)
  const [pin, setPin] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [mode, setMode] = useState<'register' | 'login'>(() =>
    defaultUsername ? 'login' : 'register'
  )

  useEffect(() => {
    if (isOpen && defaultUsername) {
      setName(defaultUsername)
      setMode('login')
      setError('')
    }
  }, [isOpen, defaultUsername])

  const handleSubmit = async () => {
    if (!name.trim()) {
      setError('请输入昵称')
      return
    }
    if (usernameBlocklistRe.test(name.trim())) {
      setError('昵称包含不可使用的字符')
      return
    }
    if (!/^\d{4}$/.test(pin)) {
      setError('PIN必须为4位数字')
      return
    }
    setLoading(true)
    setError('')
    try {
      if (mode === 'register') {
        const res = await registerUser(name.trim(), pin)
        if (res.ok) {
          localStorage.setItem('pin', pin)
          onRegistered(name.trim(), res.user)
        } else if (res.needLogin) {
          setMode('login')
          setError('该昵称已注册，请输入PIN登录')
        } else {
          setError(res.error || '注册失败')
        }
      } else {
        const res = await loginUser(name.trim(), pin)
        if (res.ok) {
          localStorage.setItem('pin', pin)
          onRegistered(name.trim(), res.user)
        } else {
          setError(res.error || '登录失败')
        }
      }
    } catch {
      setError('网络错误，请重试')
    }
    setLoading(false)
  }

  return (
    <BaseModal title={mode === 'register' ? '注册' : '登录'} isOpen={isOpen} handleClose={() => {}}>
      <div className="mt-4 space-y-3">
        <input
          type="text"
          maxLength={20}
          className="w-full px-3 py-2 border border-gray-300 rounded-md text-center text-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          placeholder="你的昵称"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
        />
        <input
          type="password"
          maxLength={4}
          inputMode="numeric"
          className="w-full px-3 py-2 border border-gray-300 rounded-md text-center text-lg tracking-widest dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          placeholder="4位数字PIN"
          value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
          onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
        />
        {error && (
          <p className="text-sm text-red-600">{error}</p>
        )}
        <button
          type="button"
          disabled={loading}
          className="w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm disabled:opacity-50"
          onClick={handleSubmit}
        >
          {loading ? '请稍候...' : mode === 'register' ? '注册并进入' : '登录'}
        </button>
        <p className="text-xs text-center text-gray-500 dark:text-gray-400">
          {mode === 'register' ? (
            <span>已有账号？<button className="text-indigo-600 underline" onClick={() => { setMode('login'); setError('') }}>去登录</button></span>
          ) : (
            <span>没有账号？<button className="text-indigo-600 underline" onClick={() => { setMode('register'); setError('') }}>去注册</button></span>
          )}
        </p>
      </div>
    </BaseModal>
  )
}
